/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { makeStyles } from "@material-ui/core";

export const useAboutDialogNavBarButtonStyles = makeStyles({
    appLogo: {
        height: 80,
    },
});
